import GLOBAL from './global';

const Perf: any = GLOBAL.performance;
const getEntries: any = GLOBAL.performance && GLOBAL.performance.getEntries;
const getEntriesByType = GLOBAL.performance && GLOBAL.performance.getEntriesByType;
const getEntriesByName = GLOBAL.performance && GLOBAL.performance.getEntriesByName;
const PerformanceObserver: any = GLOBAL.performance && GLOBAL.PerformanceObserver;

export {
    getEntriesByType,
    getEntriesByName,
    PerformanceObserver,
    Perf,
};
export default getEntries;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/getEntries.ts